import React, { type ComponentProps, type FC, type ReactNode } from 'react';

import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { ProfileCardWrapper } from '@confluence/profile/entry-points/ProfileCardWrapper.ts';

export type ApprovalProfileCardProps = {
	ariaLabel: string;
	children: ReactNode;
	fullName: string;
	onPointerClick?: () => void;
	position?: ComponentProps<typeof ProfileCardWrapper>['position'];
	principalId?: string | null;
	principalType?: string | null;
	trigger?: ComponentProps<typeof ProfileCardWrapper>['trigger'];
};

const ApprovalProfileCardLoading: FC<ApprovalProfileCardProps> = ({ children }) => <>{children}</>;

const LoadableApprovalProfileCard: LoadableType<ApprovalProfileCardProps> = LoadableLazy({
	name: 'ApprovalProfileCard',
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ApprovalProfileCard" */ './ApprovalProfileCard.tsx'
			)
		).ApprovalProfileCard,
	loading: ApprovalProfileCardLoading,
});

export const ApprovalProfileCard: FC<ApprovalProfileCardProps> = (props) => {
	const { children, principalId, principalType } = props;

	if (principalType !== 'USER' || !principalId) {
		return children;
	}

	return <LoadableApprovalProfileCard {...props} />;
};
